import { getPreferredExperience } from '@/console/host/experience-storage';
import { ExperienceId } from '@/console/host/experience.types';
import { isModernRouteSupported } from '@/console/host/route-support';

export const EXPERIENCE_PARAM = 'experience';

export const resolveExperience = (
  pathname: string,
  storedPreference: ExperienceId = getPreferredExperience(),
  search: string = globalThis.location?.search ?? '',
): ExperienceId => {
  if (new URLSearchParams(search).get(EXPERIENCE_PARAM) === 'classic') {
    return 'classic';
  }

  if (storedPreference !== 'modern') return 'classic';

  return isModernRouteSupported(pathname) ? 'modern' : 'classic';
};
